<template>
  <div>
    <v-app >
      <top-navigation-bar></top-navigation-bar>
      <side-menu />
      <v-main >
        <slot />
      </v-main>
    </v-app>
  </div>
</template>
<script>
  import { ForgeMessage, isParentOrigin } from '@Utils/forgeMessageUtils';
  import { updateMarkupsStyle } from '@Scripts/js/forgeService';
  import { drawImage64OnPlane, drawImageOnPlane } from '@Scripts/js/forgeviewer';
  import store from '@Store';
  import SideMenu from '@Share/components/AdminSideMenu.vue';
  import TopNavigationBar from '@Share/components/TopNavigationBar.vue';

  export default {
    name: 'admin-layout',
    created() {
      if (isParentOrigin()) {
        let forgeMessage = new ForgeMessage('get-next-test-blind-sequence', null);
        forgeMessage.send();
      }

      window.updateMarkupsStyle = updateMarkupsStyle;
      window.drawImage64OnPlane = drawImage64OnPlane;
      window.drawImageOnPlane = drawImageOnPlane;

      store.dispatch('GET_DATA_FROM_LOCAL_STORAGE');
      store.dispatch('USER/GET');
      store.dispatch('BLOB_STORAGE/GET_LIMITS');
    },
    mounted() {
      store.dispatch('DISPOSE_3D_VIEWER');
    },
    unmounted() {
      store.dispatch('DISPOSE_3D_VIEWER');
    },
    components: { SideMenu, TopNavigationBar },
  };
</script>

<style>
  @import '../styles/main.css';

  #app {
    width: 100vw;
    height: 100vh;
  }
</style>
